export type RecaptchaVisible = boolean;

export const SET_RECAPTCHA_VISIBLE = 'SET_RECAPTCHA_VISIBLE';
